module.exports = __webpack_public_path__ + "img/RonocaValley.7f5ce2b8.png";